import Auth from '@/packages/Auth';
import { Middleware, MiddlewareNext } from '@/router/middlewares/types';
import { Route } from 'vue-router';

export const GuestMiddleware: Middleware = {
  handle(to: Route, from: Route, next: MiddlewareNext, data?: any) {
    const destroyTokenForRoutes = ['auth.impersonation', 'auth.reset-password'];
    const currentRoute = to.name || '';
    if (destroyTokenForRoutes.includes(currentRoute)) {
      Auth.destroyToken();
    }
    if (Auth.isAuthenticated()) {
      return next({
        // redirect to dashboard
        name: 'dashboard'
      });
    }
  }
};
